module.exports = __webpack_public_path__ + "img/linkedin.110d6d1d.png";